import { Alert, type AlertProps } from "@mui/material";
import type { JSX } from "react";

interface ErrorAlertProps extends Omit<AlertProps, "children"> {
  message: string;
}

export default function ErrorAlert({
  message,
  ...rest
}: ErrorAlertProps): JSX.Element {
  return (
    <Alert severity="error" {...rest}>
      {message}
    </Alert>
  );
}
